import React from "react";
import { Accordion } from "react-bootstrap";

import { CourseModule } from "./CourseModule";

export function CourseProgram({ course }) {
  const modules = course?.modules || [];

  if (modules.length === 0) {
    return (
      <div className="modern-course-empty-content">
        <div>
          <i className="fas fa-book-open" />
        </div>

        <h3>Contenido no disponible</h3>
        <p>Este curso todavía no tiene módulos publicados.</p>
      </div>
    );
  }

  return (
    <div className="modern-course-modules">
      <Accordion defaultActiveKey={String(modules[0].id)}>
        {modules.map((courseModule, moduleIndex) => (
          <CourseModule
            key={courseModule.id}
            courseModules={modules}
            courseModule={courseModule}
            moduleIndex={moduleIndex}
          />
        ))}
      </Accordion>
    </div>
  );
}
